import { Injectable } from '@angular/core';
import { ImportResultApiModel } from '../../api/api-models/ImportResultApiModel';
import { LayoutService } from './layout.service';
import { ImportResult } from '../models/import-result.model';

@Injectable()
export class HandleImportService {
  private importResult: ImportResult = new ImportResult();

  constructor(private layoutService: LayoutService) {}

  public handleImportResults(data: ImportResultApiModel, entityName: string, entityPluralName: string): ImportResult {
    this.importResult.ImportResultsCanBeDownloaded = data.WasProcessed;
    this.importResult.AlertClass = data.WasProcessed
      ? data.FailedCount
        ? 'alert-info'
        : 'alert-info'
      : 'alert-danger';

    if (!data.WasProcessed) {
      this.importResult.AlertMessage = `The uploaded file does not have ${entityName} data.`;
      return this.importResult;
    }
    this.importResult.ImportResultsBlob = new Blob([data.Blob], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64'
    });

    if (data.ImportedCount) {
      this.importResult.AlertMessage = `${data.ImportedCount} ${
        data.ImportedCount > 1 ? entityPluralName + ' have' : entityName + ' has'
      } been added or updated. `;
    } else {
      this.importResult.AlertMessage = `No ${entityPluralName} have been added or modified. `;
    }

    if (data.FailedCount) {
      this.importResult.AlertMessage += ` ${data.FailedCount} ${
        data.FailedCount > 1 ? entityPluralName : entityName
      } could not be added or updated. `;
    }

    this.layoutService.scrollToTop();

    return this.importResult;
  }
}
